import * as THREE from 'three'
import Experience from './Experience.js'
import Baked from './Baked.js'
import GoogleLeds from './GoogleLeds.js'
import LoupedeckButtons from './LoupedeckButtons.js'
import CoffeeSteam from './CoffeeSteam.js'
import TopChair from './TopChair.js'
import ElgatoLight from './ElgatoLight.js'
import BouncingLogo from './BouncingLogo.js'
import Screen from './Screen.js'

export default class World
{
    constructor(_options)
    {
        this.experience = new Experience()
        this.config = this.experience.config
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        
        this.resources.on('groupEnd', (_group) =>
        {
            if(_group.name === 'base')
            {
                this.setBaked()
                this.setGoogleLeds()
                this.setLoupedeckButtons()
                this.setCoffeeSteam()
                this.setTopChair()
                this.setElgatoLight()
                this.setBouncingLogo()
                this.setScreens()
            }
        })
    }

    setBaked()
    {
        this.baked = new Baked()
    }

    setGoogleLeds()
    {
        this.googleLeds = new GoogleLeds()
    }

    setLoupedeckButtons()
    {
        this.loupedeckButtons = new LoupedeckButtons()
    }

    setCoffeeSteam()
    {
        this.coffeeSteam = new CoffeeSteam()
    }

    setTopChair()
    {
        this.topChair = new TopChair()
    }

    setElgatoLight()
    {
        this.elgatoLight = new ElgatoLight()
    }

    setBouncingLogo()
    {
        this.bouncingLogo = new BouncingLogo()
    }

    setScreens()
    {
        this.pcScreen = new Screen(
            this.resources.items.pcScreenModel.scene.children[0],
            '/assets/videoPortfolio.mp4'
        )
        this.macScreen = new Screen(
            this.resources.items.macScreenModel.scene.children[0],
            '/assets/videoStream.mp4'
        )

        this.setScreenHover()
        this.setScreenClick()
    }

    setScreenClick()
    {
        const raycaster = new THREE.Raycaster()
        const mouse = new THREE.Vector2()
        const screenMeshes = [
            this.pcScreen.model.mesh,
            this.macScreen.model.mesh,
            this.bouncingLogo.model.group
        ]
        const modal = document.getElementById('screen-modal')
        const overlay = modal?.querySelector('.screen-modal-overlay')

        const checkClick = (_event) =>
        {
            const rect = this.experience.renderer.instance.domElement.getBoundingClientRect()
            mouse.x = ((_event.clientX - rect.left) / rect.width) * 2 - 1
            mouse.y = -((_event.clientY - rect.top) / rect.height) * 2 + 1

            raycaster.setFromCamera(mouse, this.experience.camera.instance)
            const intersects = raycaster.intersectObjects(screenMeshes, true)

            if(intersects.length > 0)
            {
                let obj = intersects[0].object
                while(obj)
                {
                    if(obj === this.pcScreen.model.mesh || obj === this.macScreen.model.mesh || obj === this.bouncingLogo.model.mesh || obj === this.bouncingLogo.model.group)
                    {
                        modal?.removeAttribute('hidden')
                        return
                    }
                    obj = obj.parent
                }
            }
        }

        const closeModal = () =>
        {
            modal?.setAttribute('hidden', '')
        }

        this.experience.renderer.instance.domElement.addEventListener('click', checkClick)
        overlay?.addEventListener('click', closeModal)
    }

    setScreenHover()
    {
        const raycaster = new THREE.Raycaster()
        const mouse = new THREE.Vector2()
        const screenMeshes = [
            this.pcScreen.model.mesh,
            this.macScreen.model.mesh,
            this.bouncingLogo.model.group
        ]

        const onMouseMove = (_event) =>
        {
            const rect = this.experience.renderer.instance.domElement.getBoundingClientRect()
            mouse.x = ((_event.clientX - rect.left) / rect.width) * 2 - 1
            mouse.y = -((_event.clientY - rect.top) / rect.height) * 2 + 1

            raycaster.setFromCamera(mouse, this.experience.camera.instance)
            const intersects = raycaster.intersectObjects(screenMeshes, true)

            let hoveredScreen = null
            let tvHovered = false

            if(intersects.length > 0)
            {
                let obj = intersects[0].object
                while(obj)
                {
                    if(obj === this.pcScreen.model.mesh) hoveredScreen = 'pc'
                    if(obj === this.macScreen.model.mesh) hoveredScreen = 'mac'
                    if(obj === this.bouncingLogo.model.mesh || obj === this.bouncingLogo.model.group) tvHovered = true
                    obj = obj.parent
                }
            }

            this.pcScreen.setHovered(hoveredScreen === 'pc')
            this.macScreen.setHovered(hoveredScreen === 'mac')
            this.bouncingLogo.setHovered(tvHovered)
        }

        this.experience.renderer.instance.domElement.addEventListener('mousemove', onMouseMove)
    }

    resize()
    {
    }

    update()
    {
        if(this.googleLeds)
            this.googleLeds.update()

        if(this.loupedeckButtons)
            this.loupedeckButtons.update()

        if(this.coffeeSteam)
            this.coffeeSteam.update()

        if(this.topChair)
            this.topChair.update()

        if(this.bouncingLogo)
            this.bouncingLogo.update()

        if(this.pcScreen)
            this.pcScreen.update()
        if(this.macScreen)
            this.macScreen.update()
    }

    destroy()
    {
    }
}